export const getAnalyticsV2Proxy = () => {
    window.maxAnalyticsEventsV2 = window.maxAnalyticsEventsV2 || []
    return window.maxAnalyticsEventsV2
}

export const getAnalyticsProxy = () => {
    window.maxAnalyticsEvents = window.maxAnalyticsEvents || []
    return window.maxAnalyticsEvents
}

export const createAnalyticsEvent = (eventName, eventData) => {
    return new CustomEvent("maxAnalyticsEvent", {
        detail: {
            eventName,
            page: window.location.pathname,
            eventData
        }
    });
}

export const submitV2AnalyticsEvent = (eventName, eventData) => {
    const analyticsEvent = createAnalyticsEvent(eventName, eventData)
    getAnalyticsV2Proxy().push(analyticsEvent)
}
